import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.GettingStartedPage.GettingStarted', {
    default: 'strengthen internal financial controls',

    auditProcesses: 'streamline audit processes',
    financialControls: 'establish internal financial controls',
    approvalAutomation: 'automate approval workflows',
    approvalSpeedup: 'speed up the approval process',

    auditAndControls: 'streamline financial controls and audit processes',
    auditAndAutomation: 'streamline financial controls and approvals',
    auditAndSpeedup: 'speed up the approval and audit processes',
    controlsAndAutomation: 'automate approvals and establish financial controls',
    controlsAndSpeedup: 'speed up approvals and establish financial controls',
    automationAndSpeedup: 'automate and speed up the approval process',

    auditControlsAutomation: 'establish financial controls and streamline approvals and audits',
    auditControlsSpeedup: 'establish financial controls, streamline audits, and automate approvals',
    auditAutomationSpeedup: 'streamline audits and speed up approvals',
    controlsAutomationSpeedup: 'establish financial controls and speed up approvals',

    skipGuide: 'Want to start using ApprovalMax without guidance?',
    skipGuideButton: 'Skip these steps.',
});
